import { jsx as _jsx } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { createContext, useContext, useMemo, useState } from 'react';
import { useSignal } from '../../hooks/use-signal';
const SearchFocusContext = createContext({
    searchFocusSignal: { signal: 0, emit: () => { } },
    resultsNavigationSignal: { signal: 0, emit: () => { } },
    searchFocused: false,
    setSearchFocused: () => { }
});
// eslint-disable-next-line react-refresh/only-export-components
export function useSearchFocus() {
    return useContext(SearchFocusContext);
}
export const SearchFocusProvider = ({ children }) => {
    const searchFocusSignal = useSignal();
    const resultsNavigationSignal = useSignal();
    const [searchFocused, setSearchFocused] = useState(false);
    const value = useMemo(() => ({ searchFocusSignal, resultsNavigationSignal, searchFocused, setSearchFocused }), [searchFocusSignal, resultsNavigationSignal, searchFocused]);
    return _jsx(SearchFocusContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=search-focus-context.js.map